<template>
  <span class="order-flags" :class="{ 'flags-blink': blink }">
    <span
      v-if="pkSb"
      class="pk-sb-dot"
      :class="[pkSb, { 'extern-red-ring': externRed }]"
      :title="dotTitle"
    ></span>

    <span
      v-if="order.partner_order"
      class="pk-sb-dot partner"
      title="Partner-/Fremdauftrag (z. B. Agentur im Hause)"
    ></span>

    <span
      v-if="order.high_quality"
      class="q1-badge"
      title="Höchste Qualität (Q1)"
    >Q1</span>

    <span
      v-if="prio === 'urgent'"
      class="prio-pill prio-pill-urgent"
      title="Priorität 1 – dringend"
    >P1</span>
    <span
      v-else-if="prio === 'critical'"
      class="prio-pill prio-pill-critical"
      title="Priorität kritisch"
    >P!</span>

    <span
      v-if="paperWarn"
      class="paper-warn"
      title="Papier nicht angeliefert!"
    >
      <i class="fas fa-exclamation-triangle"></i>
    </span>
  </span>
</template>

<script>
// Composite badge cluster for an order:
//   - PK (blue) / SB (orange) dot — with red ring when machine is fully extern
//   - Q1 badge for high_quality
//   - P1 / P! pill for urgent / critical priority
//   - Paper warning when papier_angeliefert === false (red blinking icon)
//   - Whole cluster blinks when order is a fresh auto-import (untouched).
//
// Use anywhere an order row/card is rendered:
//   <order-flags :order="item" />

import { isExternMachine } from '@/utils/machineNames'

export default {
  name: 'OrderFlags',
  props: {
    order: { type: Object, required: true }
  },
  computed: {
    pkSb() {
      const v = this.order.pk_sb
      if (v === 'pk' || v === 0) return 'pk'
      if (v === 'sb' || v === 1) return 'sb'
      return null
    },
    externRed() {
      return isExternMachine(this.order.maschine_name)
    },
    prio() {
      return this.order.priority
    },
    paperWarn() {
      return this.order.papier_angeliefert === false
        && ['order_received', 'prepress_complete', 'plates_complete'].includes(this.order.status)
    },
    blink() {
      // Fresh auto-import that nobody has touched yet
      return this.order.imported_automatically
        && this.order.status === 'order_received'
        && !this.order.last_modified_by
    },
    dotTitle() {
      return this.pkSb === 'pk'
        ? 'Pritzwalk (PK)'
        : 'Strausberg / Tastomat (SB)'
    }
  }
}
</script>

<style scoped>
.order-flags {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  flex-wrap: nowrap;
  vertical-align: middle;
}
.flags-blink {
  animation: bde-flags-blink 1.1s ease-in-out infinite;
}
@keyframes bde-flags-blink {
  0%, 100% { opacity: 1; }
  50%      { opacity: 0.35; }
}
</style>
